interface SwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label: string;
    /** Qué implica activarlo. Va debajo, en gris. */
    description?: string;
    disabled?: boolean;
}

/**
 * Interruptor para AJUSTES: cosas que están encendidas o apagadas.
 *
 * No sustituye a todas las casillas de la aplicación. Una casilla sigue siendo lo
 * correcto cuando se SELECCIONA algo dentro de un formulario o un filtro
 * ("aplicar también a los siguientes lunes", los filtros del SEPA): ahí se elige,
 * no se enciende. Esto es para lo segundo.
 *
 * Es un `<button role="switch">` y no un `<input type=checkbox>` maquillado: así
 * un lector de pantalla lo anuncia como interruptor y dice si está activado.
 */
const Switch = ({ checked, onChange, label, description, disabled = false }: SwitchProps) => (
    <div className="flex items-start justify-between gap-4 py-2">
        <div className="min-w-0">
            <div className="text-sm font-medium text-gray-800">{label}</div>
            {description && (
                <p className="text-[11px] text-gray-400 mt-0.5">{description}</p>
            )}
        </div>

        <button
            type="button"
            role="switch"
            aria-checked={checked}
            aria-label={label}
            disabled={disabled}
            onClick={() => onChange(!checked)}
            className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors
                disabled:opacity-50 disabled:cursor-not-allowed
                ${checked ? 'bg-brand-primary' : 'bg-gray-300'}`}
        >
            <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform
                    ${checked ? 'translate-x-6' : 'translate-x-1'}`}
            />
        </button>
    </div>
);

export default Switch;
